import { ButtonLink, IconChevron } from 'braid-design-system';
import type React from 'react';

import Routes from 'src/config/routes';

interface PaymentSuccessCtaProps {
  children: React.ReactNode;
}

export const PaymentSuccessCta = ({ children }: PaymentSuccessCtaProps) => (
  <ButtonLink href={Routes.DASHBOARD} id="next">
    {children}
    <IconChevron direction="right" />
  </ButtonLink>
);
